import * as React from 'react'
import FormattableTextField, { IFormattableTextFieldProps, IFormattableTextFieldState } from './FormattableTextField'

export interface IMoneyFieldProps extends IFormattableTextFieldProps {
    allowNegative?: boolean
}

export default class MoneyField extends FormattableTextField<IMoneyFieldProps> {
    public static defaultProps: Partial<IMoneyFieldProps> = {
        label: 'Tarief',
        required: true,
        inputClassName: 'ms-textAlignRight',
        prefix: '€',
        allowNegative: false,
    }

    public static getDerivedStateFromProps(
        nextProps: Readonly<IMoneyFieldProps>,
        prevState: Readonly<IFormattableTextFieldState>,
    ): IFormattableTextFieldState {
        return {
            ...prevState,
            value: prevState.format(String(nextProps.value || ''), nextProps.allowNegative),
        }
    }

    protected onChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, value: string = ''): void {
        // Propagate to any parent event listeners.
        if (this.props.onChange) {
            ;(event.target as HTMLInputElement).value = this.state.format(value, this.props.allowNegative)
            this.props.onChange(event, (event.target as HTMLInputElement).value)
        }
    }

    protected filter(value: string = ''): string {
        // If the field is not required, allow an empty value to be set.
        if (!this.props.required && !value) {
            return ''
        }

        const separatorPosition = value.indexOf(',')
        // Ensure that the minutes has 2 digits at least.
        if (separatorPosition === -1) {
            value = value + ',00'
        } else if (value.length - (separatorPosition + 1) < 2) {
            value = value + new Array(2 - (value.length - (separatorPosition + 1))).fill(0).join('')
        }

        return this.format(value, this.props.allowNegative)
    }

    protected format(value: string = '', allowNegative?: boolean): string {
        if (!allowNegative) {
            value = value.replace('-', '')
        }

        return value
            .replace(/[.,]/, ',') // Allow dots and commas as valid separators
            .replace(/[^\d-,]/, '') // Only accept numbers and commas
            .replace(/.*?(-?[\d]{0,6}[,][\d]{0,2}).*/, '$1') // Limit the format to EEEEEE,CC
            .replace(/^[0]+([\d]+[,])/, '$1') // Remove excess preceding 0
            .replace(/^[,]/, '0,') // Prepend a 0, if there is only a comma.
    }
}
